/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import Layout from "components/Layout/index";
import React, { useContext, useEffect, useRef, useState } from "react";
import { usePaymentConfigurationForm, usePaymentPackHtmlModal, useSendPaymantPackToInsurerAndClient } from "services/PaymentPackService";
import { useHeaderNbi } from 'services/QuoteService';
import { GlobalLoaderContext } from "store/context";
import { FitinsurAPI, MessageCenter } from 'utils';
import { useHistory } from 'react-router-dom';
import { Button, ClaimsSummary, RenderButtons } from "components/index";
import StepNavigation from "components/StepNavigation";
import BrokingSummary from "components/BrokingSummary";
import ContentCard from "components/ContentCard/index";
import { Form, Formik, Field } from 'formik';
import FileModal from "components/FileModal";
import TextField from 'components/Form/TextField';
import { ContentTextArea } from "./styles";
import { ButtonContainer, ButtonContent } from "components/Button/index";

function SentToXis(props) {
  const [ summary, setSummary ] = useState({});
  const [isClaims, setIsClaims] = useState(false);
  const [ file, setFile ] = useState(null);
  const [historymsg, setHistorymsg] = useState([]);

  const formik = useRef(null);
  const history = useHistory();
  const loading = useContext(GlobalLoaderContext);
  const mc = new MessageCenter();


  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: usePaymentConfigurationFormData,
    loading: usePaymentConfigurationFormLoading,
    error: usePaymentConfigurationFormError,
    status: usePaymentConfigurationFormStatus,
    request: usePaymentConfigurationFormRequest,
  } = usePaymentConfigurationForm(props.match.params.idOperation);

  const {
    data: usePaymentPackHtmlModalData,
    loading: usePaymentPackHtmlModalLoading,
    error: usePaymentPackHtmlModalError,
    status: usePaymentPackHtmlModalStatus,
    request: usePaymentPackHtmlModalRequest,
  } = usePaymentPackHtmlModal(props.match.params.idOperation);

  const {
    data: useSendPaymantPackToInsurerAndClientData,
    loading: useSendPaymantPackToInsurerAndClientLoading,
    error: useSendPaymantPackToInsurerAndClientError,
    status: useSendPaymantPackToInsurerAndClientStatus,
    request: useSendPaymantPackToInsurerAndClientRequest,
  } = useSendPaymantPackToInsurerAndClient();


  useEffect(() => {
    if ( useHeaderNbiLoading ||
      usePaymentConfigurationFormLoading ||
      usePaymentPackHtmlModalLoading ||
      useSendPaymantPackToInsurerAndClientLoading
    ) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, usePaymentConfigurationFormLoading, usePaymentPackHtmlModalLoading, useSendPaymantPackToInsurerAndClientLoading]);

  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate}
            ${message.approvalComments}
      
              `;
          tempmessage = (tempmessage + tempMsg);
        }
      )
      return tempmessage;
    }
  };


  useEffect(() => {
    let v = handleHistoryMessage()
    if (formik.current) {
      formik.current?.setFieldValue('dealAnalisysInformation', v)
    }
  }, [historymsg])

  const handleSummary = () => {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          isFramework: data.ret_value.isFramework,
          idOperation: props.match.params.idOperation,
        });

        // if (data.ret_value.paymentPackMessage) {
        //   if (formik.current) {
        //     formik.current?.setFieldValue('paymentPackMessage', data.ret_value.paymentPackMessage);
        //   }
        // }

        setHistorymsg(data.ret_value.historical);
        // setEndorsmentType(data.ret_value.endorsmentType)
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
      });
  };

  function getPaymentConfigurationForm() {
    usePaymentConfigurationFormRequest().then(({data: response}) => {
        if (response.ret_code != 200) {
          mc.error(response.ret_msg_details);
          history.goBack();
          return;
        }

        setIsClaims(response.ret_value.isClaims);

      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${getPaymentConfigurationForm.name}\n` + error);
      });
  }

  function handleFile() {
    usePaymentPackHtmlModalRequest().then(({data: resp}) => {
      if (resp.ret_code === 200) {
        const { paymentPackDocs } = resp.ret_value;
        const lPanDocs = paymentPackDocs.filter((doc) => doc.idDomain === 371);
        setFile(lPanDocs)
      } else {
        mc.error(resp.ret_msg_details);
      }
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
    });
  }
  
  function handlePaymentConfiguration() {
    history.push(`/broking/payment-pack-configuration/${props.match.params.idOperation}`)
  };

  function handleSend() {
    const body = {
      idOperation: props.match.params.idOperation,
      updateLpan: true,
    }

    useSendPaymantPackToInsurerAndClientRequest({...body}).then(({data}) => {
      if (data.ret_code !== 200) {
        mc.error(data.ret_msg_details);
        return;
      }

      return isClaims ? history.push('/claims') : history.push('/policies');
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleSend.name}\n` + error);
      console.error('fitPostReject - Error:', error);
    })
  }


  useEffect(() => {
    getPaymentConfigurationForm();
    handleFile();
    handleSummary();
  }, [])

  return (
    <Layout
      idOperation={ props.match?.params?.idOperation }
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
      {
        isClaims 
        ? 
        (

          <ClaimsSummary stage={3} idOperation={props.match.params.idOperation} />
        )
          : (
            <>
            <StepNavigation stage={3} idOperation={props.match.params.idOperation} />
            <BrokingSummary data={ summary } />
            </>
          )
      }
      <ContentCard
        title="Payment Pack"
        icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}
      >

        <Formik
          innerRef={ formik }
          initialValues={{
            dealAnalisysInformation: '',
          }}
          onSubmit={''}
        >
          {
            formikProps => (
              <Form>
                <FileModal idOperation={props.match.params.idOperation} file={ file }/>
                <Field
                  readOnly
                  label={'Deal Analysis Information'}
                  name={'dealAnalisysInformation'}
                  value={formikProps.values.dealAnalisysInformation}
                  onChange={(e) => formikProps?.setFieldValue('dealAnalisysInformation', e)}
                  component={TextField}
                />
                <ButtonContainer>
                  <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                  <RenderButtons idOperation={props.match.params.idOperation} stage={3} >
                    <ButtonContent>
                      {/* <Button
                        style={{ marginLeft: "30px", marginTop: "5px" }}
                        third
                        id="btnRegeneratePaymentPack"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handlePaymentConfiguration() }}>
                        Payment config
                      </Button> */}
                      <Button
                        style={{ marginLeft: "30px", marginTop: "5px" }}
                        primary
                        id="btnSubmit"
                        onClick={(e) => handleSend() }
                      >
                        SENT TO XIS
                      </Button>

                    </ButtonContent>
                  </RenderButtons>
                </ButtonContainer>
              </Form>
            )
          }

        </Formik>

      </ContentCard>

    </Layout>
  )
}

export default SentToXis;